import { useQuery } from "@tanstack/react-query";

import { getFootprintingFarmPurchases, getFootprintingFarmPurchasesAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM_RESOURCE_PURCHASES } from "consts";

import { RetailerPurchase } from "models";

export const useGetFootprintingFarmPurchases = (primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryFn: (primaryDataId: string) => Promise<RetailerPurchase[]> = isAdmin ? getFootprintingFarmPurchasesAdmin : getFootprintingFarmPurchases;
  return useQuery({
    queryKey: [FOOTPRINTING_FARM_RESOURCE_PURCHASES, primaryDataId],
    queryFn: () => queryFn(primaryDataId),
    enabled: !!primaryDataId,
    gcTime: 0,
  });
};
